import React from 'react'

import { ReactComponent as ArrowDown } from 'shared/assets/icons/arrowDown.svg'

export default function Button({ className = '', children, onClick }) {

  return (
    <div className={`h-[26px] w-[calc(50%-4px)] px-[16px] rounded-full flex items-center text-[12px] font-medium border-solid border-[1px] border-black cursor-pointer relative ${className}`} onClick={onClick}>
      {children}
      <ArrowDown className="w-[14px] absolute right-[10px]" />
    </div>
  )
}
